import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import AssetPlayer from "../player/AssetPlayer";

function UserFolderPlayer({ playList }) {
  return (
    <Box className="user-folder-player-wrapper">
      {playList?.length > 0 && <AssetPlayer assets={playList}></AssetPlayer>}
      {playList && !playList?.length && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: "100%",
            height: "100%",
          }}
        >
          <Typography variant="h5" color="common.white">
            There is no assets to show up in this user folder
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default UserFolderPlayer;
